import request from '@/utils/request';

/**
 * 获取卡密详情
 * @param {String} kamiCode 卡密编码
 */
export function getKamiDetail(kamiCode) {
    return request({
        url: `/h5/order/info/${kamiCode}`,
        method: 'get'
    });
}

/**
 * 第一步：填写手机号并获取验证码 (调用原直充接口)
 * @param {Object} data
 * @param {String} data.kamiCode 卡密编码
 * @param {String} data.targetMobile 充值手机号
 */
export function submitRecharge(data) {
    return request({
        url: '/h5/order/submit',
        method: 'post',
        data
    });
}

/**
 * 第二步：携带验证码最终提单
 * @param {Object} data
 * @param {String} data.kamiCode 卡密编码
 * @param {String} data.smsCode 验证码
 */
export function confirmRechargeSms(data) {
    return request({
        url: '/h5/order/submitSms',
        method: 'post',
        data
    });
}

/**
 * 获取订单结果详情
 * @param {String} kamiCode 卡密编码
 */
export function getOrderResult(kamiCode) {
    return request({
        url: `/h5/order/result/${kamiCode}`,
        method: 'get'
    });
}
